/**
 *
 * NotesLanding
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import WayFindBar from '@/components/WayFindBar.vue';
import Footer from '@/components/Footer.vue';
import Aside from '@/components/Aside.vue';
//import TabBar from '@/components/TabBar.vue';
import Spinner from '@/components/Spinner.vue';
import PzButton from '@/components/PzButton.vue';
import DownloadingTip from '@/views/Notes/components/DownloadingTip.vue';
import NotesLandingEmpty from '@/views/Notes/NotesLanding/components/NotesLandingEmpty.vue';
import NotesLandingCourse from '@/views/Notes/NotesLanding/components/NotesLandingCourse.vue';
import NotesLandingMenu from '@/views/Notes/NotesLanding/components/NotesLandingMenu.vue';
import DownloadNoteModal from '@/views/Notes/NotesLanding/components/DownloadNoteModal.vue';
import DownloadNoteHistoryModal from '@/views/Notes/NotesLanding/components/DownloadNoteHistoryModal.vue';

import { LOADING_MESSAGE } from './NotesLanding.constants';

const GetNotesLandingMixin = {
  name: 'GetNotesLandingMixin',

  computed: {
    ...mapGetters({
      mg_userInfo: 'userInfo',
    }),
  },

  methods: {
    ...mapActions('Notes/NotesLanding', {
      ma_getNotesBooksList: 'getNotesBooksList',
    }),

    getNotesBooksList() {
      if (!this.mg_userInfo.unLogin) {
        this.ma_getNotesBooksList();
      }
    },
  },

  created() {
    this.getNotesBooksList();
  },
};

const NotesLandingSelectNoteMixin = {
  name: 'NotesLandingSelectNoteMixin',

  computed: {
    ...mapGetters('Notes/NotesLanding', {
      mg_currentCourse: 'currentCourse',
    }),
  },

  methods: {
    selectCourse() {
      this.$scrollTo(`#course-${this.mg_currentCourse.course_id}`, 500, {
        container: 'main',
        easing: 'linear',
        offset: -90,
      });
    },
  },
};

export default {
  name: 'NotesLanding',

  mixins: [GetNotesLandingMixin, NotesLandingSelectNoteMixin],

  components: {
    WayFindBar,
    Footer,
    //TabBar,
    Aside,
    Spinner,
    PzButton,
    DownloadingTip,
    NotesLandingEmpty,
    NotesLandingCourse,
    NotesLandingMenu,
    DownloadNoteModal,
    DownloadNoteHistoryModal,
  },

  data: () => {
    return {
      loadingMessage: LOADING_MESSAGE,
    };
  },

  computed: {
    ...mapState('Notes', {
      ms_isGeneratingPdf: 'isGeneratingPdf',
    }),

    ...mapState('Notes/NotesLanding', {
      ms_notesList: 'notesList',
      ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      immLoading: 'immLoading',
      mg_userInfo: 'userInfo',
    }),

    ...mapGetters('Notes/NotesLanding', {
      mg_lstNotesGroupActive: 'lstNotesGroupActive',
      mg_lstNotesGroupDisabled: 'lstNotesGroupDisabled',
    }),
  },
};
